// Org IDs in Auth0
export const GRANDSKY_ORG_ID = 'org_cjtoPq5F2xDCGyD4'
export const AEROX_ORG_ID = 'org_g89oLRIrv7vaSfNV'
